import { render } from "./FirstTimerEmpty.vue?vue&type=template&id=016c1705&scoped=true"
import script from "./FirstTimerEmpty.vue?vue&type=script&lang=js"
export * from "./FirstTimerEmpty.vue?vue&type=script&lang=js"

import "./FirstTimerEmpty.vue?vue&type=style&index=0&id=016c1705&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-016c1705"]])

export default __exports__